import { render, staticRenderFns } from "./aggrement.vue?vue&type=template&id=8f215c62&scoped=true&"
import script from "./aggrement.vue?vue&type=script&lang=js&"
export * from "./aggrement.vue?vue&type=script&lang=js&"
import style0 from "./aggrement.vue?vue&type=style&index=0&id=8f215c62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f215c62",
  null
  
)

export default component.exports